import {eVendorStatus} from "./eVendorStatus.enum";
import {StatusDataModel} from "./status-data.model";

export class StatusMapper {
  private static readonly _vendorStatus: { [key: string]: StatusDataModel<eVendorStatus> } = {
    [eVendorStatus.active]: {status: 'Active', statusClass: 'active', eStatus: eVendorStatus.active},
    [eVendorStatus.inactive]: {status: 'Inactive', statusClass: 'inactive', eStatus: eVendorStatus.inactive}
  }

  static getVendorStatusOb(status: eVendorStatus): StatusDataModel<eVendorStatus> {
    return this._vendorStatus[status];
  }
}
